import { MultipleChoiceSpoergsmaal } from './MultipleChoiceSpoergsmaal';
import { DelopgaveBedoemmelsesFaktor } from './DelopgaveBedoemmelsesFaktor';
import { OpgaveBedoemmesAfEnum } from './enums/OpgaveBedoemmesAfEnum';
import { OpgavenBedoemmesEfterEnum } from './enums/OpgavenBedoemmesEfterEnum';
import { ResultatAngivesIEnum } from './enums/ResultatAngivesIEnum';

export class Delopgave {
        public id: string;
        public opgavenBedoemmesAf: OpgaveBedoemmesAfEnum;
        public opgavenBedoemmesEfter: OpgavenBedoemmesEfterEnum;
        public resultatetAngivesI: ResultatAngivesIEnum;
        public bedoemmelsesvejledning: string;
        public indhold: string;
        public kendtVaerdi: string;
        public opgaveId: string;
        public order: number;
        public titel: string;
        public skalStartesManuelt: boolean;
        public multipleChoiceSpoergsmaal: MultipleChoiceSpoergsmaal[];
        public delopgaveBedoemmelsesFaktorer: DelopgaveBedoemmelsesFaktor[];
}   



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/models/Delopgave.ts